<template>
  <!-- Modal -->
  <div class="modal fade" id="PaymentModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('purchase.withdrawal_processing')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-success">{{translations('purchase.notification_message')}}</div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{translations('purchase.withdrawal_date')}}</th>
                <th>{{translations('purchase.customer_name')}}</th>
                <th>{{translations('purchase.payment')}}</th>
                <th>{{translations('purchase.paid')}}</th>
                <th>{{translations('purchase.withdrawal_amount')}}</th>
                <th>{{translations('purchase.transfer_fee')}}</th>
                <th>{{translations('purchase.difference')}}</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <tr>
                <td>
                  <input type='date' v-model="paymentAt" class='form-control'>
                </td>
                <td>{{partner}}</td>
                <td class="right">{{Number(amount).toLocaleString()}}</td>
                <td class="right">{{Number(paid).toLocaleString()}}</td>
                <td>
                  <input v-model="payment" type="text" class="form-control">
                </td>
                <td>
                  <input v-model="transferFee" type="text" class="form-control" value="200">
                </td>
                <td class="right">{{Number(remainingPrice).toLocaleString()}}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addPayment()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'PaymentModal',
  components: {
    VueElementLoading
  },
  props: {
    purchaseId: Number,
    amount: Number,
    paid: Number,
    // balance: Number,
    partner: String
  },
  data: function () {
    return {
      paymentAt: this.$invoiceTools.getCurrentDate(),
      payment: 0,
      transferFee: 0,
      remainingPrice: 0,
      isSearching: false
    }
  },
  watch: {
    payment: {
      handler: function (data, oldData) {
        if (isNaN(Number(data))) {
          this.payment = oldData
        } else {
          this.calcRemainingPrice()
        }
      }
    },
    transferFee: {
      handler: function (data, oldData) {
        if (isNaN(Number(data))) {
          this.transferFee = oldData
        } else {
          this.calcRemainingPrice()
        }
      }
    }
    // balance: {
    //   handler: function (data, oldData) {
    //     this.calcRemainingPrice()
    //   }
    // }
  },
  mounted: function () {
    window.$('#PaymentModal').on('shown.bs.modal', () => {
      this.calcRemainingPrice()
    })
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    calcRemainingPrice: function () {
      this.remainingPrice = Number(this.amount) - Number(this.paid) - (Number(this.payment) + Number(this.transferFee))
    },

    addPayment: function () {
      if (this.paymentAt.replace('/', '') === '') {
        this.$toastr.warning('出金日をご入力してください')
        return
      }
      if (isNaN(Number(this.payment))) {
        this.$toastr.warning('出金額を半角数字でご入力してください')
        return
      }
      if (isNaN(Number(this.transferFee))) {
        this.$toastr.warning('振込手数料を半角数字でご入力してください')
        return
      }

      this.$dialog.confirm('この出金処理を進行しますか?').then(async () => {
        this.isSearching = true
        try {
          let paramUpdate = {
            purchase_id: this.purchaseId,
            payment_at: this.paymentAt,
            transfer_fee: this.transferFee,
            payment: this.payment
          }
          const response = await this.$http.post(this.$api_url.purchase_payment, paramUpdate)
          const result = response.data
          console.log('PaymentModal:addPayment: ', result)
          if (result.status === true) {
            this.$toastr.success('出金処理の進行に成功しました。', 'Success')
            this.$parent.purchaseInfo.is_paid = result.is_paid
            this.$parent.purchaseInfo.total_paid += Number(this.payment) + Number(this.transferFee)
            this.payment = 0
            this.transferFee = 0
            this.$refs.closeModal.click()
          } else {
            this.$toastr.error(result.message, 'エラー')
          }
          this.isSearching = false
        } catch (error) {
          console.log('PaymentModal:addPayment:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          this.isSearching = false
        }
      })
    }
  }
}
</script>
